<template>
  <ProductPreview></ProductPreview>
</template>

<script>
import ProductPreview from "@/components/ProductPreview";

export default {
  name: "App",
  components: {
    ProductPreview,
  },
};
</script>

<style lang="scss">
@import "./styles/global.scss";
</style>
